// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3gxnA","header":"MergedInvoice_header__34lj8"};